import isMobile from 'ismobilejs'

export default class Device {
  constructor() {
    this.device = null
    this.init()
  }
  init() {
    // IE チェック
    if (document.documentMode && document.uniqueID) {
      document.documentElement.classList.add('ie11')
    }
    // デバイス判定
    if (isMobile(window.navigator).phone) {
      this.device = 'phone'
      document.documentElement.classList.add('device-phone')
    } else if (isMobile(window.navigator).tablet) {
      this.device = 'tablet'
      document.documentElement.classList.add('device-tablet')
      // タブレット用 viewport
      window.addEventListener('resize', this.updateMetaViewport, false)
      window.addEventListener(
        'orientationchange',
        this.updateMetaViewport,
        false
      )
      let ev = document.createEvent('UIEvent')
      ev.initEvent('resize', true, true)
      window.dispatchEvent(ev)
    } else {
      this.device = 'other'
      document.documentElement.classList.add('device-other')
    }

    this.setViewportHeight()
    window.addEventListener('resize', this.setViewportHeight)
  }
  setViewportHeight() {
    this.vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', this.vh + 'px')
  }
  updateMetaViewport() {
    // ビューポート設定
    let siteWidth = 1280 //基準となるブレークポイント
    let viewportContent = 'width=' + siteWidth + 'px'
    document
      .querySelector("meta[name='viewport']")
      .setAttribute('content', viewportContent)
  }
  get getDevice() {
    return this.device
  }
}
